import mapLabelsDirective from "./map-labels-directive";

export {mapLabelsDirective};
